import { render, staticRenderFns } from "./PlansTab.vue?vue&type=template&id=55d51084"
import script from "./PlansTab.vue?vue&type=script&lang=js"
export * from "./PlansTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports